import { combineReducers } from "@reduxjs/toolkit";

import { approvedManagersListingReducer } from "./ApprovedManagers/ApprovedManagersListingSlice";
import { invitedManagersListingReducer } from "./InvitedManagers/InvitedManagersListingSlice";

export const managerDirectoryReducer = combineReducers({
  invitedManagersListing: invitedManagersListingReducer,
  approvedManagersListing: approvedManagersListingReducer,
});
